import { Box } from "@twilio-paste/core/box";
import { Button } from "@twilio-paste/core/button";

import { Alert } from "@twilio-paste/core/alert";
import { ArrowForwardIcon } from "@twilio-paste/icons/esm/ArrowForwardIcon";

import {
  HomeInsightsBlock,
  trackingDetails,
} from "@twiliointernal/e2-commons-shared-definitions";
import { copy } from "../definitions";
import { useWiseOwlContext } from "../../../hooks";
import constants, { homeInsightWrapperPrompt } from "../definitions/constants";
import { Insight, InsightLink } from "../definitions/types";

interface HomeInsightsProps {
  block: HomeInsightsBlock;
}

const HomeInsights = ({ block }: HomeInsightsProps) => {
  const {
    handlers: {
      handleStartNewChat,
      handleTrackEvent,
      handleToggleLiveChatPreEngagement,
      handleUpdateLiveChatPreEngagementValues,
    },
    applicationProps: { displayName, ingress },
  } = useWiseOwlContext();
  const { insights } = block.values;
  const firstInsight = insights[0];

  const handleHomeInsightClick = ({
    insightText,
    link,
  }: {
    insightText: string;
    link?: InsightLink;
  }): void => {
    if (link) {
      if (
        link.type === "liveChat" &&
        handleToggleLiveChatPreEngagement &&
        handleUpdateLiveChatPreEngagementValues
      ) {
        handleUpdateLiveChatPreEngagementValues({
          message: copy.homeInsights.liveChatDefaultMessage,
          productCategory: constants.ATO_INSIGHT_PRODUCT_CATEGORY,
        });

        handleToggleLiveChatPreEngagement();
        return;
      }

      if (link.url) {
        window.open(link.url, "_blank");
        return;
      }
    }

    if (handleStartNewChat) {
      handleStartNewChat({ input: homeInsightWrapperPrompt(insightText) });
    }

    if (handleTrackEvent) {
      handleTrackEvent(
        trackingDetails.wiseOwl.homeInsightClicked(displayName),
        {
          insightText,
          ingress,
        }
      );
    }
  };

  const renderInsightButtons = (insight: Insight) => {
    const insightText = insight.text;

    if (insight.links && insight.links.length > 0) {
      return (
        <Box as="div" marginTop="space40">
          {insight.links?.map((link) => {
            return (
              <Box as="span" key={link.type} marginRight="space30">
                <Button
                  variant="secondary"
                  size="rounded_small"
                  onClick={() => handleHomeInsightClick({ insightText, link })}
                >
                  {link.linkText}
                </Button>
              </Box>
            );
          })}
        </Box>
      );
    }

    return (
      <Box as="div" marginTop="space40">
        <Button
          variant="secondary"
          size="rounded_small"
          onClick={() => handleHomeInsightClick({ insightText })}
        >
          {copy.homeInsights.button.getHelp}
          <ArrowForwardIcon decorative />
        </Button>
      </Box>
    );
  };

  return (
    <Box as="section" paddingY="space30">
      <Alert variant="warning">
        <strong>{copy.homeInsights.heading}</strong>

        <div>
          {firstInsight.text}
          {renderInsightButtons(firstInsight)}
        </div>
      </Alert>
    </Box>
  );
};

export default HomeInsights;
